import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import type { ActionDispatcher } from './action-dispatcher';
import type { ActionRequest } from './action-request';
import { ActionResponseError, type ActionEvent } from './action-response';

/**
 * Implementation of an `ActionDispatcher` that may be
 * used as the fallback, when no other chained `ActionHandler`
 * did handle the request.
 */
@Injectable()
export class FallbackActionDispatcher implements ActionDispatcher {
  dispatch(req: ActionRequest<any>): Observable<ActionEvent<any>> {
    return throwError(() => new ActionResponseError(req, 'Unsupported action'));
  }

  isExecuteable(action: string): Observable<boolean> {
    // Since no handler handled this action, the action won't
    // be executeable.
    return of(false);
  }
}
